var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Det du försöker hitta verkar inte finnas här. Är du säker på att det var hit du ville?")])}
var staticRenderFns = []

export { render, staticRenderFns }